import React from "react"
import Layout from "../components/layout"
import Comments from "../components/comments"
import { graphql, Link } from "gatsby"
import Seo from "../components/seo"
import StoryMeta from "../components/story-meta"
import Share from "../components/share"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const style = {
  // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  borderRadius: 3,
  border: 0,
  width: "100%",

  color: "black",
  padding: "0 0px",
  // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
}

export const fragment = graphql`
  fragment story on WpStory {
    title
    content
    excerpt
    slug
    comments {
      nodes {
        content
        agent
        dateGmt
        date(formatString: "MMMM DD, YYYY")
        author {
          node {
            email
            name
          }
        }
        approved
      }
    }
    storyData {
      author
      fieldGroupName
      storyContent
      readTime
      storyQuiz {
        answers {
          fieldGroupName
          isCorrect
          proposedAnswer
        }
        fieldGroupName
        question
      }
      yearReleased
    }
    storyTypes {
      nodes {
        id
        slug
        uri
        name
        count
      }
    }
    storyCategorys {
      nodes {
        id
        slug
        uri
        name
        count
      }
    }
    date
    databaseId
    id
    slug
    featuredImage {
      node {
        sourceUrl
        mediaDetails {
          sizes {
            sourceUrl
            name
            mimeType
            height
            fileSize
            file
            width
          }
        }

        small: localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              formats: [AUTO, WEBP, AVIF]
              width: 500
              height: 280
              placeholder: BLURRED
            )
          }
        }
        medium: localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              formats: [AUTO, WEBP, AVIF]
              width: 320
              height: 180
              placeholder: BLURRED
            )
          }
        }
        large: localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              formats: [AUTO, WEBP, AVIF]
              width: 600
              placeholder: BLURRED
            )
          }
        }
        xl: localFile {
          childImageSharp {
            gatsbyImageData(
              quality: 100
              formats: [AUTO, WEBP, AVIF]
              width: 910
              placeholder: BLURRED
            )
          }
        }
        altText
        caption
        databaseId
        id
      }
    }
  }
`

export default function StoryRead({ data }) {
  const post = data.allWpStory.nodes[0]
  const image = post.featuredImage?.node?.sourceUrl
    ? post.featuredImage?.node?.sourceUrl
    : null
  const featured = post.featuredImage
    ? getImage(post.featuredImage.node.xl)
    : null
  return (
    <Layout
      current={post}
      customShareTitle={`Stories for Kids - Read ${post.title}`}
    >
      <Seo
        title={`${post.title} - Read Fairy Tales Free online`}
        description={`A child friendly modern take on the classic fairy tale ${
          post.title
        } - ${post.excerpt.replace(/(<([^>]+)>)/gi, "")}`}
        url={`${process.env.GATSBY_SITE_URL}/${post.slug}/`}
        image={
          post.featuredImage?.node?.sourceUrl
            ? post.featuredImage?.node?.sourceUrl
            : null
        }
        story={true}
      />
      <div className={"xl:pr-20"}>
        <header className="bg-white dark:bg-gray-900 dark:text-white ">
          <h1 className="text-3xl lg:text-8xl  text-gray-900 dark:text-white mb-8 lg:mb-12">
            {post.title}
          </h1>
        </header>
        {featured && (
          <div className={"mb-12"}>
            <GatsbyImage
              transformOptions={{ fit: "COVER", cropFocus: "ATTENTION" }}
              aspectRatio={1 / 1}
              image={featured}
              alt={post.title}
            />
          </div>
        )}
        <div
          className={
            "article-content mb-8  border-dashed pl-4 pr-4 pt-4 pb-0 text-sm border-4 border-light-blue-500"
          }
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
        <h2 className="text-xl  text-gray-900 dark:text-white mb-8">
          {" "}
          Read {post.title}
        </h2>
        <div
          className={"article-content mb-0"}
          dangerouslySetInnerHTML={{
            __html: post.storyData?.storyContent || "No content here",
          }}
        />
        <div className={"mb-8"}>
          <p className=" end background text-center font-bold text-2xl">
            <span>The End</span>
          </p>
        </div>
        {post.storyData.storyQuiz && (
          <div className={"mt-8 mb-12"}>
            <p>
              Finished the story? Please feel free to try our supplimentary quiz
              for children.
            </p>
            <p>
              <Link className={"font-bold"} to={`/${post.slug}/quiz`}>
                Take the '{post.title}' Quiz
              </Link>
            </p>
          </div>
        )}

        <StoryMeta post={post} />

        <div className={"w-full mt-8 mb-8"}>
          <Share
            post={post}
            img={image}
            customShareTitle={`Stories for Kids - Read ${post.title}`}
          />
        </div>
        <Comments post={post} />
      </div>
    </Layout>
  )
}
export const query = graphql`
  query ($slug: String!) {
    allWpStory(filter: { slug: { eq: $slug } }) {
      nodes {
        ...story
      }
    }
  }
`
